var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgReply = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 6C2.5 5.72386 2.72386 5.5 3 5.5H9.18182C11.5248 5.5 13.5 7.2508 13.5 9.5C13.5 11.7492 11.5248 13.5 9.18182 13.5H7.54545C7.26931 13.5 7.04545 13.2761 7.04545 13C7.04545 12.7239 7.26931 12.5 7.54545 12.5H9.18182C11.0562 12.5 12.5 11.1168 12.5 9.5C12.5 7.88321 11.0562 6.5 9.18182 6.5H3C2.72386 6.5 2.5 6.27614 2.5 6Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.35357 2.31344C6.54884 2.5087 6.54884 2.82528 6.35357 3.02055L3.37379 6.00033L6.35357 8.98011C6.54884 9.17537 6.54884 9.49195 6.35357 9.68721C6.15831 9.88247 5.84173 9.88247 5.64647 9.68721L2.31313 6.35388C2.11787 6.15862 2.11787 5.84203 2.31313 5.64677L5.64647 2.31344C5.84173 2.11818 6.15831 2.11818 6.35357 2.31344Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReply, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/reply.249649d0.svg";
export { ForwardRef as ReactComponent };